import React, { PureComponent, Fragment } from 'react';
import { Input, Form, Button as AntButton, Spin, message } from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { api } from '@comall-backend-builder/core/lib/services';

import { checkPassword, errorHandle, logout as logoutFun } from '../../services';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
    },
};
const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 10,
            offset: 6,
        },
    },
};

interface PasswordProps {
    click: () => void;
    form: FormComponentProps['form'];
}

class password extends PureComponent<PasswordProps, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            confirmDirty: false,
            spinning: false,
            passwordDirty: false,
        };
    }

    // 新密码与确认密码校验
    compareToFirstPassword = (rule: any, value: any, callback: any) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('newPassword')) {
            callback('两次密码输入不一致!');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule: any, value: any, callback: any) => {
        const { form } = this.props;
        if (value && value === form.getFieldValue('oldPassword')) {
            callback('新密码不能与之前的密码相同!');
        }
        if (!checkPassword(value)) {
            callback('请输入8~20位密码，数字、大写字母、小写字母、特殊字符至少包含三种');
        }
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true });
        }
        callback();
    };

    validateToNewPassword = (rule: any, value: any, callback: any) => {
        const { form } = this.props;
        if (value && this.state.passwordDirty) {
            form.validateFields(['newPassword'], { force: true });
        }
        callback();
    };

    handleBlur = (e: any, type: string) => {
        const { value } = e.target;
        this.setState({ [type]: this.state[type] || !!value });
    };
    
    handleSubmit = (e: any) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err: any, values: any) => {
            if (!err) {
                this.setState({ spinning: true });
                const { oldPassword, newPassword } = values;
                const params = {
                    oldPassword,
                    newPassword
                };

                api.put(
                    params,
                    { apiPath: `/homepage/edit_password`, apiRoot: `${ENV.API_ROOT}` }
                )
                    .then(() => {
                        setTimeout(() => {logoutFun()}, 500);
                        message.success('密码修改成功', () => {
                            this.goBack();
                        });
                    })
                    .catch(errorHandle)
                    .finally(() => {
                        this.setState({ spinning: false });
                    });
            }
        });
    };
    goBack = () => {
        this.props.click();
    };
    render() {
        const {
            form: { getFieldDecorator },
        } = this.props;
        const { spinning } = this.state;
        return (
            <Fragment>
                <Spin spinning={spinning}>
                    <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                        <Form.Item label="原密码">
                            {getFieldDecorator('oldPassword', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入原密码!',
                                    },
                                    {
                                        validator: this.validateToNewPassword,
                                    },
                                ],
                            })(<Input.Password placeholder="请输入原密码" />)}
                        </Form.Item>
                        <Form.Item label="新密码">
                            {getFieldDecorator('newPassword', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入新密码!',
                                    },
                                    {
                                        validator: this.validateToNextPassword,
                                    }
                                ],
                            })(
                                <div style={{ position: 'relative' }}>
                                    <Input.Password
                                        maxLength={16}
                                        placeholder="请输入新密码"
                                        onBlur={(e) => this.handleBlur(e, 'passwordDirty')}
                                    />
                                </div>
                            )}
                        </Form.Item>
                        <Form.Item label="确认新密码">
                            {getFieldDecorator('confirmPassword', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请确认新密码!',
                                    },
                                    {
                                        validator: this.compareToFirstPassword,
                                    },
                                ],
                            })(
                                <Input.Password
                                    maxLength={16}
                                    placeholder="请再次输入新密码"
                                    onBlur={(e) => this.handleBlur(e, 'confirmDirty')}
                                />
                            )}
                        </Form.Item>
                        <Form.Item {...tailFormItemLayout}>
                            <AntButton type="primary" htmlType="submit">
                                保存修改
                            </AntButton>
                            <AntButton style={{ marginLeft: 10 }} onClick={this.goBack}>
                                取消
                            </AntButton>
                        </Form.Item>
                    </Form>
                </Spin>
            </Fragment>
        );
    }
}
export default Form.create<PasswordProps>()(password);
